import React from "react";
// Chakra imports
import {
  Box,
 
  Heading,
  useColorModeValue,
} from "@chakra-ui/react";
import DefaultAuth from "layouts/auth/Default";
import './signin.css';

import MicrosoftLogo from "assets/img/Microsoft-logo.svg";
import Logo1 from "assets/img/embrill-logo.svg";


const API_URL = process.env.REACT_APP_BASE_URL;

function SignIn() {
  

  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
 

  const signIn = async () => {
    window.location.assign(`${API_URL}/login`);
  };
 
  return (
    <DefaultAuth>
      <Box
        className="signin-auth"
       
      >
        <Box me="auto" mt="100px" className="signin-main">
        <img alt="embrill-logo" src={Logo1}/>
        <span class="jss4">Welcome to Embrill Finance</span>         
         <Heading color={textColor} fontSize="36px" mb="10px">
            Sign In
          </Heading>
          <span class="jss6">Login using your organization account!</span>
       
            <div className="jss7"
             onClick={() => {
              signIn();
            }}
            >
            <img src={MicrosoftLogo} alt="logo" className="jss9"/>
            <span class="jss8">Sign In with Microsoft</span>
            </div>
            
        </Box>
      </Box>
    </DefaultAuth>
  );
}

export default SignIn;
